<input type="tel" class="form-control" inputmode="tel" autocomplete="tel" maxlength="20"
       [class.form-control-sm]="small"
       [id]="inputId || null"
       [attr.tabindex]="tabindex"
       [placeholder]="placeholder"
       [disabled]="disabled()"
       [value]="display()"
       (input)="onInput($event)"
       (keydown.enter)="onEnter($event)"
       (blur)="onBlur()">
